<template>
  <div class="cleaner-home">
    <div class="section-header">
      <div class="section-title">待领取任务</div>
      <div class="section-count">{{ pendingTasks.length }}</div>
    </div>

    <div class="task-list">
      <div class="task-card" v-for="task in pendingTasks" :key="task.id">
        <div class="card-header">
          <div class="room-name">{{ task.room_name }} - {{ task.shop_name }}</div>
          <div class="status-badge blue">待领取</div>
        </div>
        <div class="card-body">
          <div class="info-row">
            <van-icon name="location-o" size="16" color="#999" />
            <div class="info-text">包间地址：{{ task.shop_address }}</div>
          </div>
          <div class="info-row">
            <van-icon name="clock-o" size="16" color="#999" />
            <div class="info-text">退房时间：{{ task.create_time }}</div>
          </div>
          <div class="info-row">
            <van-icon name="orders-o" size="16" color="#999" />
            <div class="info-text">待清洁 {{ task.room_name }}</div>
          </div>
        </div>
        <div class="card-footer">
          <van-button round type="info" size="block" @click="handleAccept(task)">领取任务</van-button>
        </div>
      </div>

      <van-empty v-if="!loadingPending && pendingTasks.length === 0" description="暂无待领取任务" />
    </div>

    <div class="section-header">
      <div class="section-title">进行中任务</div>
      <div class="section-count">{{ processingTasks.length }}</div>
    </div>

    <div class="task-list">
      <div class="task-card" v-for="task in processingTasks" :key="task.id">
        <div class="card-header">
          <div class="room-name">{{ task.room_name }} - {{ task.shop_name }}</div>
          <div class="status-badge orange">保洁中</div>
        </div>
        <div class="card-body">
          <div class="info-row">
            <van-icon name="location-o" size="16" color="#999" />
            <div class="info-text">包间地址：{{ task.shop_address }}</div>
          </div>
          <div class="info-row">
            <van-icon name="clock-o" size="16" color="#999" />
            <div class="info-text">退房时间：{{ task.create_time }}</div>
          </div>
          <div class="info-row">
            <van-icon name="clock-o" size="16" color="#999" />
            <div class="info-text">开始时间：{{ task.start_time_str }}</div>
          </div>
          <div class="info-row">
            <van-icon name="friends-o" size="16" color="#999" />
            <div class="info-text">
              保洁员 {{ task.cleaner_name }}({{ task.cleaner_phone }}) 正在保洁。
            </div>
          </div>
        </div>
        <div class="card-footer" v-if="cleanerInfo.id && cleanerInfo.id == task.cleaner_user_id">
          <van-button round type="success" size="block" @click="handleContinue(task)"
            >继续任务</van-button
          >
        </div>
      </div>

      <van-empty v-if="!loadingProcessing && processingTasks.length === 0" description="暂无进行中任务" />
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import { acceptTask, unclearlist, usertasklist } from '../../api/lxz/cleaner'
import storage from '../../utils/storage'

export default {
  name: 'CleanerHome',
  data() {
    return {
      pendingTasks: [],
      processingTasks: [],
      cleanerInfo: {},
      loadingPending: false,
      loadingProcessing: false,
      page: 1,
      taskPage: 1
    }
  },
  created() {
    this.cleanerInfo = storage.get('cleanerInfo') || {}
  },
  mounted() {
    this.refresh()
  },
  methods: {
    async refresh() {
      await Promise.all([this.fetchUnclearlist(), this.fetchUserTasklist()])
    },
    async handleAccept(task) {
      try {
        await Dialog.confirm({
          title: '确认领取任务',
          message: '确认领取任务吗？'
        })
      } catch (e) {
        return
      }

      try {
        const res = await acceptTask({ cleanerLogId: task.id })
        if (res && res.status === 200) {
          Toast.success('领取成功')
          // await this.refresh()
          this.$router.push(`/cleanerOrder/order/${task.id}`)
        } else {
          Toast.fail('领取失败')
        }
      } catch (e) {
        Toast.fail('领取失败')
      }
    },
    async fetchUnclearlist() {
      this.loadingPending = true
      try {
        const res = await unclearlist({ page: this.page })
        if (res && res.status === 200) {
          const list = res.data && res.data.list ? res.data.list : { total: 0, data: [] }
          this.pendingTasks = list.data || []
        }
      } finally {
        this.loadingPending = false
      }
    },
    async fetchUserTasklist() {
      this.loadingProcessing = true
      try {
        const res = await usertasklist({ filterType: 'pending', page: this.taskPage })
        if (res && res.status === 200) {
          const list = res.data && res.data.list ? res.data.list : { total: 0, data: [] }
          this.processingTasks = list.data || []
        }
      } finally {
        this.loadingProcessing = false
      }
    },
    handleContinue(task) {
      this.$router.push(`/cleanerOrder/order/${task.id}`)
    }
  }
}
</script>

<style scoped>
.cleaner-home {
  min-height: 100vh;
  padding: 12px;
  background: #f5f7fa;
}
.section-header {
  display: flex;
  align-items: center;
  margin: 8px 0 10px;
  padding-left: 4px;
}
.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-right: 8px;
}
.section-count {
  background: #e0e0e0;
  color: #666;
  font-size: 12px;
  padding: 1px 8px;
  border-radius: 12px;
  min-width: 22px;
  text-align: center;
}
.task-list {
  margin-bottom: 18px;
}
.task-card {
  background: #fff;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f0f0;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.room-name {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-right: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}
.status-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 6px;
  color: #fff;
  flex-shrink: 0;
}
.status-badge.blue {
  background: #1989fa;
}
.status-badge.orange {
  background: #ff9900;
}
.card-body {
  margin-bottom: 12px;
}
.info-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}
.info-row:last-child {
  margin-bottom: 0;
}
.info-text {
  font-size: 13px;
  color: #666;
  margin-left: 8px;
  flex: 1;
  line-height: 1.4;
}
.card-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
